import firebase from "firebase"
import firebaseApp from "../firebaseApp"

const db = firebaseApp.firestore()

export function deleteBlacklist(data, userEmail){    
    return new Promise((resolve)=>{
        var docRef = db.collection('users').doc(userEmail);
        docRef.update({'blacklist': firebase.firestore.FieldValue.arrayRemove(data)})
        resolve()
    })
}

export function deleteWhitelist(data, userEmail){    
    return new Promise((resolve)=>{
        var docRef = db.collection('users').doc(userEmail);
        docRef.update({'whitelist': firebase.firestore.FieldValue.arrayRemove(data)})
        resolve()
    })
}